import { NgControl, ValidationErrors } from '@angular/forms';
import { FormErrorsFormatter } from './error-formatter';
import { ValidatorErrorFormat } from './default-form-errors-formatter.types';
import { TranslateService } from '@ngx-translate/core';

export class DefaultFormErrorsFormatter implements FormErrorsFormatter {
  public readonly displayMaxErrors: number = 1;
  public readonly validatorsFormatters: ValidatorErrorFormat;
  public readonly fieldsFormatters: Record<string, ValidatorErrorFormat> = {};

  constructor(private translate: TranslateService) {
    this.validatorsFormatters = {
      required: () => this.translate.instant('generic-validator-error'),
    };
  }

  public format(control: NgControl): string {
    const errors: ValidationErrors | null = control.errors;

    if (!errors) return '';

    const fieldFormatter = control.name && this.fieldsFormatters?.[control.name];
    const defaultFormatter = this.validatorsFormatters;

    const formattedErrors: string[] = Object.keys(errors).reduce((acc, errorKey) => {
      const formatter =
        (fieldFormatter && fieldFormatter[errorKey]) || (defaultFormatter && defaultFormatter[errorKey]);

      if (formatter) {
        acc.push(formatter(errors[errorKey], control.name));
      }

      return acc;
    }, [] as string[]);

    return formattedErrors.slice(0, this.displayMaxErrors).join(', ');
  }
}
